import { Injectable } from '@angular/core';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { EndUserLicenseAgreementItem, EulaListSearchCriteria } from '../models/end-user-license-agreement.model';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { EndUserLicenseAgreementListState, EulaListStateModel } from './end-user-license-agreement-list.state';
import {
  EndUserLicenseAgreementListInitialState,
  EndUserLicenseAgreementListLoad,
} from './end-user-license-agreement-list.actions';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class EndUserLicenseAgreementListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<EulaListStateModel> = this.store.select(EndUserLicenseAgreementListState.getState);
  loaded$: Observable<boolean> = this.store.select(EndUserLicenseAgreementListState.getLoaded);
  items$: Observable<EndUserLicenseAgreementItem[]> = this.store.select(EndUserLicenseAgreementListState.getItems);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Eulas)
      .subscribe((searchCriteria: EulaListSearchCriteria) => {
        this.store.dispatch(new EndUserLicenseAgreementListLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new EndUserLicenseAgreementListInitialState());
  }
}
